import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterOut',
    standalone: false
})
export class FilterOutPipe implements PipeTransform {

  transform(values: any[], columns: string[], text:string): any[] {
    if (!values)
      return values;

    if (!text || text.trim()=="")
      return values;

    text = text.toUpperCase();
    return values.filter(x => {
      for (let c of columns) {
        let value: string = x[c].toString();
        if (value.toUpperCase().indexOf(text)>=0)
          return false;
      }
      return true;
    });
  }

}
